import { FLAG_TONE } from '../lib/constants.js';

export function ScorecardCard({ label, value, sub, flag = 'gray' }) {
  const tone = FLAG_TONE[flag] || FLAG_TONE.gray;
  return (
    <div className="card" style={{ borderLeft: `4px solid ${tone.bar}`, padding: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.6px' }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: '#212121', marginTop: 4, lineHeight: 1.1 }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: tone.text, marginTop: 4, fontWeight: 500 }}>{sub}</div>}
    </div>
  );
}
